"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publishStatusFromString = exports.isPublishStatus = exports.supportedPublishStatus = void 0;
exports.supportedPublishStatus = [
    'draft',
    'published',
    'unpublished',
];
const isPublishStatus = (value) => {
    const arr = [...exports.supportedPublishStatus];
    return arr.includes(value);
};
exports.isPublishStatus = isPublishStatus;
const publishStatusFromString = (value) => {
    if ((0, exports.isPublishStatus)(value)) {
        return value;
    }
    throw Error(`'${value}' is not a valid status name`);
};
exports.publishStatusFromString = publishStatusFromString;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHVibGlzaC5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvcHVibGlzaC5tb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDYSxRQUFBLHNCQUFzQixHQUFHO0lBQ3BDLE9BQU87SUFDUCxXQUFXO0lBQ1gsYUFBYTtDQUNMLENBQUE7QUFZSCxNQUFNLGVBQWUsR0FBRyxDQUFDLEtBQWEsRUFBMEIsRUFBRTtJQUN2RSxNQUFNLEdBQUcsR0FBRyxDQUFDLEdBQUcsOEJBQXNCLENBQWEsQ0FBQTtJQUVuRCxPQUFPLEdBQUcsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUE7QUFDNUIsQ0FBQyxDQUFBO0FBSlksUUFBQSxlQUFlLG1CQUkzQjtBQUVNLE1BQU0sdUJBQXVCLEdBQUcsQ0FBQyxLQUFhLEVBQWlCLEVBQUU7SUFDdEUsSUFBSSxJQUFBLHVCQUFlLEVBQUMsS0FBSyxDQUFDLEVBQUU7UUFDMUIsT0FBTyxLQUFLLENBQUE7S0FDYjtJQUVELE1BQU0sS0FBSyxDQUFDLElBQUksS0FBSyw4QkFBOEIsQ0FBQyxDQUFBO0FBQ3RELENBQUMsQ0FBQTtBQU5ZLFFBQUEsdUJBQXVCLDJCQU1uQyJ9